import { makeQueryFunction, makeUseQueryHook } from '@graphql/functions'
import { GetEmbeddedDocument } from '@graphql/queries/GetEmbedded.graphql'

export const useGetEmbedded = makeUseQueryHook({
    query: GetEmbeddedDocument,
})

export const getEmbedded = makeQueryFunction({
    query: GetEmbeddedDocument,
})
